// extracted by mini-css-extract-plugin
module.exports = {"root":"VULur","animator":"_2tgLn"};